const mapStateToThis = ({ config }) => {
  const { phoneLength } = config;

  return {
    phoneLength,
  };
};

@Inject('$ngRedux')
class LspPhoneLengthDirective {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
    this.require = 'ngModel';
    this.restrict = 'A';
    if (this.phoneLength) {
      this.link = (...args) => {
        args[3].$validators.lspPhoneLength = function(value) {
          return (value || '').length === 0 || value.length === this.phoneLength;
        }.bind(this)
      };
    }
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default LspPhoneLengthDirective;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/lsp-phone-length-validator/lsp-phone-length-directive.js